import { Box } from '@mui/material';
import React, { createContext, useContext, useEffect, useState } from 'react'
import { getAirlineCommissions } from '../../controllers/settings/airlineCommission/getAirlineCommissions';
import Pagination from '../../components/mini/Pagination';
import { DataGrid, useGridApiRef } from '@mui/x-data-grid';
import SearchInput from '../../components/mini/SearchInput';
import ModalLocal from '../../components/mini/ModalLocal';
import AirlineCommissionForm from './AirlineCommissionForm';
import { Icon } from '@iconify/react/dist/iconify.js';
import { deleteAirlineCommission } from '../../controllers/settings/airlineCommission/deleteAirlineCommission';
import { setAlertMsg } from '../../redux/reducers/modal/snackBarSlice';
import { useDispatch } from 'react-redux';


const ActionContext = createContext();

const filterItems = [
  {items:[{id: 0,field: 'status',operator: '',value:''}]},
  {items:[{id: 1,field: 'status', operatorValue: 'is', value: 'paid'}]},
  {items:[{id: 2,field: 'status', operatorValue: 'is', value: 'pending'}]},
  {items:[{id: 2,field: 'status', operatorValue: 'is', value: 'cancelled'}]},
  {items:[{id: 2,field: 'status', operatorValue: 'is', value: 'refund'}]},
];

export default function AirlineCommissions() {
    const [data,setData] = useState([])
    const [fetchedData,setFetchedData] = useState(null);
    const [filter,setFilter] = useState(filterItems[0]);
    const [openDelete,setOpenDelete] = useState(false);
    const [openEdit,setOpenEdit] = useState(false);
    const [openCreate,setOpenCreate] = useState(false);
    const [paginationModel,setPaginationModel] = useState({pageSize: 25,page: 0})
    const [loadings,setLoadings] = useState({load: true,remove: false})

    const apiRef = useGridApiRef();
    
    const dispatch = useDispatch();
    
    useEffect(() => {
        load();
        //eslint-disable-next-line
    },[])

    async function load() {
        setLoadings({...loadings,load: true})
        const res = await getAirlineCommissions();
        setLoadings({...loadings,load: false})
        if(res?.return) {
            setData(res?.data)
            setFetchedData(res?.data)
        }
    }
    
    const columns = [
        {field: 'airlineCode',headerName: 'Airline Code',flex: 1,minWidth: 130,
        renderCell: (params) => {
            if(!params.value)
            return null;
    
            return (
            <div className='flex gap-1 justify-between w-full relative'>
                {params.value}
            </div>
            )
        }
        },
        {field: 'airlineName', headerName: 'Airline Name',flex: 1,
        renderCell: (params) => {
            if(!params.value)
                return null;
    
            return (
                <div className='flex gap-1 justify-between w-full relative'>
                    <p className="flex-1 overflow-hidden overflow-ellipsis" title={params.value}>
                    {params.value}
                    </p>
                </div>
            )

        }
        },
        {field: 'commission', headerName: 'Commission',flex: 1,
        renderCell: (params) => (
            params.value || ''
        )
        },
        {field: 'action',headerName: 'Action',flex: 1,minWidth: 130,
        renderCell: (params) => {
            // if(!params.value)
            // return null;
    
            return (
                <ActionCol params={params} reload={load} />
            )
        }
        },
    ];

    
  function handleSearch(val) {
    if(!val)
      return setData(fetchedData);

    console.log(fetchedData)
    val = val?.toLowerCase();

    setData((fetchedData||[])?.filter(obj => (
      obj?.airlineCode?.toLowerCase()?.includes(val) ||
      obj?.airlineName?.toLowerCase()?.includes(val) ||
      obj?.commission?.toString()?.toLowerCase()?.includes(val)
      // (new Date(obj?.date)).toDateString()?.toLowerCase()?.includes(val) ||
      // (parseInt(obj?.amount) <= val) ||
      // obj?.status?.includes(val)
    )))
  }

  async function handleDelete() {
    setLoadings({...loadings,remove: true})
    const res = await deleteAirlineCommission(openDelete?.id);
    setLoadings({...loadings,remove: false})
    if(res?.return) {
        dispatch(setAlertMsg(['success',res?.msg]));
        setOpenDelete(false);
        load();
    } else 
        dispatch(setAlertMsg(['error',res?.msg]));
  }
    
  return (
    <div className='w-full mx-10'>
      <Box className='bg-secondary'>
        <div className='flex gap-4 justify-between items-center my-3 p-3'>
          <SearchInput className='text-theme1' onChange={handleSearch} />
            <div>
                <button className='btn2' onClick={() => setOpenCreate(true)}>{'Create Commission'}</button>
            </div>
        </div>


        <ActionContext.Provider value={{setOpenEdit,setOpenDelete}}>
            <DataGrid rows={data} columns={columns} loading={loadings?.load} autoHeight hideFooter={false}
            // getRowId={(row) => row.id}
            apiRef={apiRef}
            initialState={{
                sorting: {
                sortModel: [{field: "createdDate",sort: 'desc'}]
                },
            }}
            filterModel={filter}
            onFilterModelChange={(newFilter) => setFilter(newFilter)}
            
            // slots={{pagination: Pagination}}
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}

            // onCellEditStart={params => setRowId(params.id)}
            // hideFooterPagination
            checkboxSelection
            />
        </ActionContext.Provider>

        <Pagination perPage={10} total={46} apiRef={apiRef} />
      </Box>

      <ModalLocal open={openCreate} setOpen={setOpenCreate}>
        <AirlineCommissionForm close={() => setOpenCreate(false)} data={openCreate} callback={() => {setOpenCreate(false); load()}} />
      </ModalLocal>
      <ModalLocal open={openEdit} setOpen={setOpenEdit}>
        <AirlineCommissionForm close={() => setOpenEdit(false)} data={openEdit} callback={() => {setOpenEdit(false); load()}} />
      </ModalLocal>
      <ModalLocal open={openDelete} setOpen={setOpenDelete}>
        <div className='flex flex-col gap-4 bg-secondary p-6 rounded-md'>
            <h3>Are you sure you want to delete?</h3>
            <div className='flex gap-4 items-center justify-between'>
                <button className='btn_outlined' onClick={() => setOpenDelete(false)}>Cancel</button>
                <button disabled={loadings?.remove} className='p-4 py-2 rounded-md !bg-red-500 text-white' onClick={handleDelete}>{loadings?.remove ? 'Please Wait' : 'Delete'}</button>
            </div>
        </div>
      </ModalLocal>
    </div>
  )
}



function ActionCol({params}) {
  const {setOpenEdit,setOpenDelete} = useContext(ActionContext)

  return (
    <div className='flex gap-2 w-full relative'>
      <button onClick={() => setOpenEdit(params?.row)} className='border p-1 rounded-md bg-primary/10'>
        <Icon icon='tabler:edit' className='!w-5 !h-5' />
      </button>
      <button onClick={() => setOpenDelete(params?.row)} className='border p-1 rounded-md bg-primary/10'>
        <Icon icon='mi:delete' className='!w-5 !h-5 text-red-500' />
      </button>
      {/* <DotMenu  anchor={anchorEl} setAnchor={setAnchorEl} parentControl={true}>
        <MenuItem onClick={handleRemove}>Remove</MenuItem>
        <MenuItem onClick={handleRemove}>Remove</MenuItem>
      </DotMenu> */}
    </div>
  )
}
